<template>
    <modal
        :id="modalId"
        :title="title"
        :ok-disabled="loading"
        @ok.prevent="save"
        @hide="hideModal"
    >
        <busy-modal :show="loading"></busy-modal>
        <span>{{ description }}</span>
    </modal>
</template>

<script>
    import API from '../../../../api';
    import { DOOR_LOCKS_E_RENTAL_LOCK_ACCOUNT_DISCONNECT_ENDPOINT } from '../../../../endpoints';
    import BusyModal from '../../../generic/busy-modal/busy-modal.vue';
    import Modal from '../../../generic/modal/modal.vue';

    export default {
        name: 'DoorLockDisconnectModal',
        components: {
            BusyModal,
            Modal,
        },
        props: {
            modalId: String,
            title: String,
            description: String,
            disconnect: {
                type: Function,
                default: () => Promise.resolve(),
            },
        },
        data() {
            return {
                loading: false,
            }
        },
        methods: {
            hideModal() {
                this.$bvModal.hide(this.modalId);
            },
            async save() {
                this.loading = true;

                try {
                    await this.disconnect();
                    this.$emit('success-disconnect');
                    this.$nextTick(() => {
                        this.hideModal();
                    })
                } catch (err) {
                    this.errorToast({text: 'Something went wrong while disconnecting.'})
                } finally {
                    this.loading = false;
                }
            },
        }
    }
</script>
